export default __webpack_public_path__ + "static/media/ip5X.13e11611.svg";